import { render, staticRenderFns } from "./DashboardReportLayout.vue?vue&type=template&id=588c7c98&scoped=true&"
import script from "./DashboardReportLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardReportLayout.vue?vue&type=script&lang=js&"
import style0 from "./DashboardReportLayout.vue?vue&type=style&index=0&id=588c7c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c7c98",
  null
  
)

component.options.__file = "DashboardReportLayout.vue"
export default component.exports